import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './App.css';  // Import the CSS file  

const ChatInterface = () => {
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const chatWindowRef = useRef(null);

  const sendMessage = async () => {
    if (inputMessage.trim() === '') return;

    const newMessage = { role: 'user', content: inputMessage };
    const updatedHistory = [...messages, newMessage].slice(-10);
    setMessages(updatedHistory);
    setInputMessage('');
    setIsLoading(true);

    try {
      const response = await axios.post('https://mosalesagentpoc.azurewebsites.net/chat', {
        history: updatedHistory.map(msg => ({ role: msg.role, content: msg.content }))
      });

      const assistantMessage = { role: 'assistant', content: response.data.content };
      setMessages([...updatedHistory, assistantMessage]);
    } catch (error) {
      console.error('Error sending message:', error);
      setMessages([...updatedHistory, {
        role: 'assistant',
        content: 'Sorry, I encountered an error. Please try again.'
      }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="chat-container">
      <div className="chat-window" ref={chatWindowRef}>
        {messages.map((msg, index) => (
          <div key={index} className={msg.role}>
            <strong>{msg.role === 'user' ? 'You' : 'Assistant'}</strong>
            <div>{msg.content}</div>
          </div>
        ))}
        {isLoading && (
          <div className="assistant">
            <strong>Assistant</strong>
            <div className="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        )}
      </div>
      <div className="input-container">
        <input
          type="text"
          value={inputMessage}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          placeholder="Type your message..."
          disabled={isLoading}
        />
        <button
          onClick={sendMessage}
          disabled={isLoading || inputMessage.trim() === ''}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatInterface;  